import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { axiosGetCall, axiosPatchCall, axiosPostCall } from '../../../services/apisCall';
import Logger from '../../../lib/Logger';
const logger = new Logger("kycListTable");
import { renderErrorMessage, renderSuccessMessage } from '../../../lib/toastMessage';
import DeleteIcon from '@mui/icons-material/Delete';

// component
import { PaginationTable } from './paginationTable';
import TableFilters from './tableFilter';

//mui 
import { Box, List, ListItem, TableCell, Button, Typography, IconButton } from '@mui/material';
import Iconify from 'src/components/iconify';
//mui icons
import MoreVertIcon from '@mui/icons-material/MoreVert';
import BlockIcon from '@mui/icons-material/Block';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import LogoutIcon from '@mui/icons-material/Logout';
import { Icon } from '@iconify/react';


import { useNavigate } from 'react-router-dom';
import KycDetailsModal from '../../kyc/kycDetailsModal';
import { CustomMenu } from '../../../components/menu/customMenu';
import { checkUserRole } from '../../../utils/common';
import AddUpdateSmtp from './addUpdateSmtp';
import {checkButtonAccess} from "src/utils/common"


const columns = [
    { id: 'host', label: 'Host', minWidth: 110, align: 'start' },
    { id: 'user', label: 'user', minWidth: 110, align: 'center' },
    { id: 'password', label: 'password', minWidth: 110, align: 'center' },
    { id: 'port', label: 'port', minWidth: 110, align: 'center' },
    { id: 'type', label: 'Type', minWidth: 110, align: 'center' },
    { id: 'mailFrom', label: 'Mail By', minWidth: 110, align: 'center' },
    { id: 'status', label: 'Status', minWidth: 110, align: 'center' },

    { id: 'created_at', label: 'Created By', minWidth: 110, align: 'center' },
    { id: 'actions', label: 'Action', minWidth: 110, align: 'center' },
   
];

export const Smtp = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [rows, setRows] = useState([])
    const [count, setCount] = useState(0)
    const [selectedPanelStatus, setSelectedPanelStatus] = useState("")

    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(true)
    const [networkError, setNetworkError] = useState(false)
    const [loading, setLoading] = useState(true)

    const [ addOpenModal, setaddOpenModal ] = useState("")
    const [loadit, forceLoad] = useState(false);
    const handleCloseModal = () => {
        setaddOpenModal(false);
    }
    

    const handleChange = (value) => setSearch(value)

    const getSmtpList = async () => {
        try {
            const skip = rowsPerPage * page;
            const params = { skip, limit: rowsPerPage }
            if (checkUserRole() === "admin") params.userRole = "agent";
            if (search) params.user = search
            if (selectedPanelStatus) params.status = selectedPanelStatus
            setNetworkError(false)
            const { result, totalCount } = await axiosGetCall("smtpList", params)
                       
            setRows(result)
            setCount(totalCount)
        } catch (error) {
            logger.error("AdminUserLIstTable.jsx ,getAdminUserList ,adminUsersList", error);
            setNetworkError(true)
            setRows([])
            setCount(0)
            renderErrorMessage(error?.message)
        }
        setLoading(false)
    }

    useEffect(() => {
        if (load || loadit) {
            setLoading(true)
            getSmtpList()
            setLoad(false)
        }
    }, [load,loadit])

 const tableFilter = <TableFilters search={search} handleChange={handleChange} setLoad={setLoad} count={count} />

 const updateAnnouncementStatus = async (row, status) => {
        try {
            const { message } = await axiosPatchCall("updateStatus", { id: row?._id,  status:status })
            renderSuccessMessage(message)
            getSmtpList()
        } catch (error) {
            logger.error("erorr in update status")
            renderErrorMessage(error?.message)
        }
    }
    const rejectStatus = (row) => {
        // setSelectedRow(row)
        // setConfirmModal(true);
    }
    const ActionJsx = ({ id, align, value, row }) => {
        return (
            <TableCell
                key={id}
                align={align}
                sx={{
                    color: 'grey.400',
                    borderBottom: '0.5px dashed',
                    borderColor: 'grey.300',
                    size: 'small'
                }}>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "5px"
                    }}
                >
                                       {checkButtonAccess("updateServer", "w") && <>
                        {row?.status !== 1 && <IconButton onClick={() => updateAnnouncementStatus(row, 1)}><Iconify icon="mdi:tick" sx={{ color: "green" }} /></IconButton>}
                        {row?.status !== 2 && <IconButton onClick={() => updateAnnouncementStatus(row, 2)}><Iconify icon="mdi:close" sx={{ color: "red" }} /></IconButton>}
                    </>}
                </Box>
            </TableCell>
        )
    }
   
    const AddButton = () => {
        return (
            <Button
           
                startIcon={<PersonAddIcon />}
                sx={{
                     height:"35px",
                    backgroundColor: 'rgb(33, 43, 54)',
                    color: 'grey.100',
                    p: '0px 20px 0px 20px',
                    '&:hover': {
                        backgroundColor: 'rgb(69, 79, 91)'
                    }
                }}
             onClick={() => setaddOpenModal(true)}
            >
               Add SMTP
            </Button>
        )
    }
    return (
        <>
            {/* <ToastContainer /> */}
            
            <PaginationTable
                page={page}
                tableFilter={tableFilter}
                addButton={<AddButton />}
                ActionJsx={ActionJsx}
                setLoad={setLoad}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                count={count}
                error={networkError}
                loading={loading}
                setLoading={setLoading}
                rows={rows}
                columns={columns}
                handleChange={handleChange}
                search={search}
                size={'small'}
                calculatedHeight={337}
            />
            <AddUpdateSmtp
            openModal={addOpenModal}
            forceLoad={forceLoad}
            loadit={loadit}
            handleCloseModal={handleCloseModal}
            title="Add SMTP"/>
        </>
    )
}
